import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
// Importing data for the properties
import BlogDataList from "./property-data.json";
// Importing icons for map and ratings
import Icon from "@mdi/react";
import { mdiMapMarkerRadiusOutline, mdiStar, mdiArrowRightThin, mdiDotsGrid, mdiAbacus, mdiAbTesting, mdiAccessPointPlus, mdiStepForward } from "@mdi/js";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import '../../App.css';


// FeaturedProperties component displays a grid of property cards with hover effects and animations
export default function FeaturedProperties() {

  // Store the list of properties
  const [BlogItemList] = useState(BlogDataList);

  // Track the index of the hovered property
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Ref to track the title element for IntersectionObserver
  const titleRef = useRef(null);

  // IntersectionObserver to trigger animation when the section is in view
  useEffect(() => {
    const titleEl = titleRef.current; // Cache ref
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-lines");
          } else {
            entry.target.classList.remove("animate-lines");
          }
        });
      },
      { threshold: 0.3 }
    );

    if (titleEl) observer.observe(titleEl);

    return () => {
      if (titleEl) observer.unobserve(titleEl); // Use cached ref
    };
  }, []);

  return (
    <>
      <section className="section" id="blog">
        <Container>
          <Row>
            <Col md={12}>
              <div className="section-title-box">
                <h1 className="section-title" ref={titleRef}>
                   Properties<span className="text-primary"> Highlights</span>
                  <div className="title-line before-line" />
                  <div className="title-line after-line" />
                </h1>
              </div>
            </Col>
          </Row>

          {/* Motion wrapper for the row to animate scaling on viewport entry */}
          <motion.div whileInView={{ scale: 1 }} initial={{ scale: 0.8 }}
            transition={{
              type: "linear",
              stiffness: 100,
              duration: 1,
            }}
          >
            {/* Grid of property cards */}
            


            <Row className="hover-cards-container">
              {BlogItemList.blogItemListData.map((data, i) => (
                <Col md={6} xxl={2} key={i} className="mt-4 mt-xxl-0">
                  <div className="hover-card-wrapper position-relative"
                    onMouseEnter={() => setHoveredIndex(i)}
                    onMouseLeave={() => setHoveredIndex(null)}
                  >
                    <AnimatePresence>
                      {/* Overlay effect on hover */}
                      {hoveredIndex === i && (
                        <motion.div className="hover-overlay" layoutId="hoverBackground"
                          initial={{ opacity: 0 }}
                          animate={{
                            opacity: 1,
                            transition: { duration: 0.25 },
                          }}
                          exit={{
                            opacity: 0,
                            transition: { duration: 0.2, delay: 0.1 },
                          }}
                        />
                      )}
                    </AnimatePresence>
                    <Card className="overflow-hidden mb-0 h-100 rounded-3 position-relative">
                      <Card.Body>
                        {/* Property image */}
                        <img src={require(`../../images/property-img/${data.blogImg}`)} alt="" className="rounded img-fluid img-shadow blog-img"/>
                        <div className="blog-content">
                          {/* Title and status (For Sale badge) */}
                          <div className="d-flex justify-content-between mt-4 mb-2">
                            <h6 className="fs-17 mb-0 me-2">{data.blogTitle}</h6>
                            <div>
                              <Badge bg="soft-success">New</Badge>
                            </div>
                          </div>
                          {/* Location with map icon */}
                          {/* <div className="d-flex text-white opacity-85  fs-14">
                            <Icon path={mdiMapMarkerRadiusOutline} className="icon-size-18 me-2"/> {data.blogLocation}
                          </div> */}
                          {/* Rating and price */}
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <div className="d-flex text-warning">
                              {/* Star rating */}
                              <Icon path={mdiAccessPointPlus} className="icon-size-18 me-1" />
                              <Icon path={mdiAccessPointPlus} className="icon-size-18 me-1" />
                              <Icon path={mdiAccessPointPlus} className="icon-size-18 me-1" />
                              <Icon path={mdiAccessPointPlus} className="icon-size-18 me-1" />
                              <Icon path={mdiAccessPointPlus} className="icon-size-18" />
                            </div>
                            <h4 className="mb-0">{data.blogItemPrice}</h4>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                </Col>
              ))}
            </Row>
          </motion.div>


          <Row className="hover-cards-2-container">
              {BlogItemList.blogItemListDataofrow2.map((data, i) => (
                <Col md={6} xxl={2} key={i} className="mt-4 mt-xxl-0">
                  <div className="hover-card-wrapper position-relative"
                    onMouseEnter={() => setHoveredIndex(i)}
                    onMouseLeave={() => setHoveredIndex(null)}
                  >
                    <AnimatePresence>
                      {/* Overlay effect on hover */}
                      {hoveredIndex === i && (
                        <motion.div className="hover-overlay" layoutId="hoverBackground"
                          initial={{ opacity: 0 }}
                          animate={{
                            opacity: 1,
                            transition: { duration: 0.25 },
                          }}
                          exit={{
                            opacity: 0,
                            transition: { duration: 0.2, delay: 0.1 },
                          }}
                        />
                      )}
                    </AnimatePresence>
                    <Card className="overflow-hidden mb-0 h-100 rounded-3 position-relative">
                      <Card.Body>
                        {/* Property image */}
                        <img src={require(`../../images/property-img/${data.blogImg}`)} alt="" className="rounded img-fluid img-shadow blog-img"/>
                        <div className="blog-content">
                          {/* Title and status (For Sale badge) */}
                          <div className="d-flex justify-content-between mt-4 mb-2">
                            <h6 className="fs-17 mb-0 me-2">{data.blogTitle}</h6>
                            <div>
                              <Badge bg="soft-success">New</Badge>
                            </div>
                          </div>
                          {/* Location with map icon */}
                          {/* <div className="d-flex text-white opacity-85  fs-14">
                            <Icon path={mdiMapMarkerRadiusOutline} className="icon-size-18 me-2"/> {data.blogLocation}
                          </div> */}
                          {/* Rating and price */}
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <div className="d-flex text-warning">
                              {/* Star rating */}
                              <Icon path={mdiAccessPointPlus} className="icon-size-18 me-1" />
                              <Icon path={mdiAccessPointPlus} className="icon-size-18 me-1" />
                              <Icon path={mdiAccessPointPlus} className="icon-size-18 me-1" />
                              <Icon path={mdiAccessPointPlus} className="icon-size-18 me-1" />
                              <Icon path={mdiAccessPointPlus} className="icon-size-18" />
                            </div>
                            <h4 className="mb-0">{data.blogItemPrice}</h4>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                </Col>
              ))}
            </Row>

          {/* View More button */}
          {/* <Row className="mt-5">
            <Col md={12} className="text-center">
              <Link className="btn btn-primary btn-hover" to="/PropertyList">View More{" "}<Icon path={mdiArrowRightThin} className="icon-size-20 ms-1" /></Link>
            </Col>
          </Row> */}
        </Container>
      </section>
    </>
  );
}
